import { render, staticRenderFns } from "./coursemanage copy.vue?vue&type=template&id=c1d2f292&scoped=true&"
import script from "./coursemanage copy.vue?vue&type=script&lang=js&"
export * from "./coursemanage copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d2f292",
  null
  
)

export default component.exports